import { IString } from '@strings';
import { assertInstanceOf, immerable } from '@utils';

// Runtime data associated with an element in the Doc graph
export class ElementSpec {
  [immerable] = true;

  cls: string;
  attrs: Record<string, unknown>;

  constructor(cls: string, attrs: Record<string, unknown>) {
    this.cls = cls;
    this.attrs = {
      note: IString.EMPTY,
      assistantNote: IString.EMPTY,
      ...attrs
    };
  }

  get note(): IString {
    const value = this.attrs.note ?? IString.EMPTY;
    assertInstanceOf(value, IString);
    return value;
  }

  get assistantNote(): IString {
    const value = this.attrs.assistantNote ?? IString.EMPTY;
    assertInstanceOf(value, IString);
    return value;
  }
}
